module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Inspection: " + _vm._s(_vm.inspection.number))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), _c('Assignment', {
    key: _vm.assignmentKey,
    attrs: {
      "user_is_assignee": _vm.inspection.user_is_assignee,
      "allowed_group_ids": _vm.inspection.allowed_groups,
      "user_in_group": _vm.inspection.user_in_group,
      "assigned_to_id": _vm.inspection.assigned_to_id,
      "assign_url": _vm.assign_url
    },
    on: {
      "update-assigned-to-id": _vm.updateAssignedToId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Action\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row action-button"
  }, [(_vm.sendToManagerVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "close",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('send_to_manager')
      }
    }
  }, [_vm._v("\n                              Send to Manager\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row action-button"
  }, [(_vm.endorseVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "close",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('endorse')
      }
    }
  }, [_vm._v("\n                              Endorse\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row action-button"
  }, [(_vm.requestAmendmentVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "close",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('request_amendment')
      }
    }
  }, [_vm._v("\n                              Request Amendment\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row action-button"
  }, [(_vm.offenceVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.open_offence()
      }
    }
  }, [_vm._v("\n                              Offence\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row action-button"
  }, [(_vm.sanctionOutcomeVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.open_sanction_outcome()
      }
    }
  }, [_vm._v("\n                              Sanction Outcome\n                            ")])]) : _vm._e()])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.iTab
    }
  }, [_vm._v("Inspection")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.lTab
    },
    on: {
      "click": _vm.mapTabClicked
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.cTab
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.oTab
    }
  }, [_vm._v("Outcomes")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.rTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.iTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Inspection Details",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Inspection type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.inspection_type_id),
      expression: "inspection.inspection_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inspection, "inspection_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadSchema]
    }
  }, _vm._l((_vm.inspectionTypes), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.inspection_type) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Title")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.title),
      expression: "inspection.title"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.inspection.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.details),
      expression: "inspection.details"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.inspection.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection, "details", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Planned for (Date)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "plannedForDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.planned_for_date),
      expression: "inspection.planned_for_date"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.inspection.planned_for_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection, "planned_for_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Planned for (Time)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "plannedForTimePicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.planned_for_time),
      expression: "inspection.planned_for_time"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.inspection.planned_for_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection, "planned_for_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "search_person_organisation",
    attrs: {
      "componentTitle": "Party to be inspected",
      "parentEntity": _vm.inspectedEntity,
      "excludeStaff": true,
      "isEditable": !_vm.readonlyForm,
      "classNames": "form-control",
      "initialSearchType": _vm.inspection.party_inspected,
      "showCreateUpdate": ""
    },
    on: {
      "entity-selected": _vm.entitySelected
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    attrs: {
      "for": "inspection_inform"
    }
  }, [_vm._v("Inform party to be inspected")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.inform_party_being_inspected),
      expression: "inspection.inform_party_being_inspected"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "id": "inspection_inform"
    },
    domProps: {
      "checked": Array.isArray(_vm.inspection.inform_party_being_inspected) ? _vm._i(_vm.inspection.inform_party_being_inspected, null) > -1 : (_vm.inspection.inform_party_being_inspected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.inspection.inform_party_being_inspected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.inspection, "inform_party_being_inspected", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.inspection, "inform_party_being_inspected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.inspection, "inform_party_being_inspected", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Inspection Team",
      "Index": "1"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    ref: "inspectionteam",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    }
  }, _vm._l((_vm.inspection.all_officers), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.full_name) + "\n                                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTeamMember($event)
      }
    }
  }, [_vm._v("Add Member")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.inspection) ? _c('div', [_c('datatable', {
    ref: "inspection_team_table",
    attrs: {
      "id": "inspection-team-table",
      "dtOptions": _vm.dtOptionsInspectionTeam,
      "dtHeaders": _vm.dtHeadersInspectionTeam
    }
  })], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.lTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Location"
    }
  }, [(_vm.inspection.location) ? _c('MapLocation', {
    key: _vm.lTab,
    ref: "mapLocationComponent",
    attrs: {
      "readonly": _vm.readonlyForm,
      "marker_longitude": _vm.inspection.location.geometry.coordinates[0],
      "marker_latitude": _vm.inspection.location.geometry.coordinates[1]
    },
    on: {
      "location-updated": _vm.locationUpdated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inspection.location) ? _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsAddress
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Street")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.street),
      expression: "inspection.location.properties.street"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "street", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.town_suburb),
      expression: "inspection.location.properties.town_suburb"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.town_suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "town_suburb", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.state),
      expression: "inspection.location.properties.state"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.postcode),
      expression: "inspection.location.properties.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.country),
      expression: "inspection.location.properties.country"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "country", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.inspection.location) ? _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsDetails
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.details),
      expression: "inspection.location.properties.details"
    }],
    staticClass: "form-control location_address_field",
    domProps: {
      "value": (_vm.inspection.location.properties.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "details", $event.target.value)
      }
    }
  })])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.cTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Checklist"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.current_schema), function(item, index) {
    return (_vm.rendererVisibility) ? _c('div', [_c('compliance-renderer-block', {
      key: ("compliance_renderer_block" + index),
      attrs: {
        "component": item,
        "readonlyForm": _vm.readonlyForm
      }
    })], 1) : _vm._e()
  }), 0)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.oTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Inspection report"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Inspection report")])]), _vm._v(" "), (_vm.inspection.inspectionReportDocumentUrl) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "inspection_report_file",
    attrs: {
      "name": "inspection-report-file",
      "isRepeatable": false,
      "documentActionUrl": _vm.inspection.inspectionReportDocumentUrl,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.loadInspectionReport
    }
  })], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.rTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": !_vm.canUserAction
    }
  })], 1) : _vm._e()])])])], 1)])])])]), _vm._v(" "), (_vm.inspection.can_user_action) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('exit')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('noexit')
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.offenceInitialised) ? _c('div', [_c('Offence', {
    key: _vm.offenceBindId,
    ref: "offence",
    attrs: {
      "parent_update_function": _vm.loadInspection,
      "region_id": _vm.inspection.region_id,
      "district_id": _vm.inspection.district_id,
      "allocated_group_id": _vm.inspection.allocated_group_id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sanctionOutcomeInitialised) ? _c('div', [_c('SanctionOutcome', {
    ref: "sanction_outcome",
    attrs: {
      "parent_update_function": _vm.loadInspection
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('InspectionWorkflow', {
    key: _vm.workflowBindId,
    ref: "inspection_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b2b34ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/inspection/inspection.vue
// module id = 945
// module chunks = 0